import { create } from 'zustand'

interface NetworkStatusState {
  isOffline: boolean
  setOffline: (offline: boolean) => void
}

export const useNetworkStatusStore = create<NetworkStatusState>((set) => ({
  isOffline: false,
  setOffline: (isOffline) => set({ isOffline }),
}))
